<template>
  <div class="map-content">
    <div class="map-content__text">
      <p class="map-content__text--title">
        {{ mapOptions.filter?.wait }}{{ mapOptions.filter.subtitle }}
      </p>
      <p class="map-content__text--subtitle">{{ mapOptions.filter.floor }}</p>
    </div>
    <img
        class="map-content__image"
        v-show="!sinPlano"
        :src="fuente(imageMap ?? mapOptions.filter.image)"
        @error="sinPlano = true"
      />  
  </div>
</template>
<script setup>
  import { ref } from 'vue'

  // Un plano que no esta deja un icono roto, y no hay forma de saber desde
  // aqui cuales existen: son ficheros del propio bundle, no datos del API.
  const sinPlano = ref(false)

  defineProps({
    mapOptions: {
      type: Object
    },
    imageMap: {
      type: String
    }
  })
  const urlImg = process.env.VUE_APP_SERVER_IMG

  // Una direccion entera se usa tal cual; un nombre suelto es del bundle.
  const fuente = (imagen) =>
    String(imagen ?? '').startsWith('http') ? imagen : urlImg + 'img/' + imagen
</script>
<style lang="scss">
  @import '@/scss/mixings';
  .map-content {
    &__text {
      @include d-flex(column, initial, initial);
      &--title {
        font-size: var(--fs-large);
        font-weight: var(--fw-bold);
        line-height: 24px;
        color: var(--primary-grey-color);
      }
      &--subtitle {
        font-size: var(--fs-small);
        line-height: 20px;
        color: var(--secondary-grey-color);
      }
    }
    &__image {
      width: 100%;
      @media screen and (min-width: $md-breakpoint) {
        width: 500px;
        padding-top: 10px;
      }
    }
  }
</style>
